import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tablePerfilOpcionesView.
 * @extends JetView
 */
export default class tablePerfilOpcionesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        return {
            css: 'my_permissions', // CSS class for styling
            cols: [
                {
                    rows: [
                        {
                            type: 'space', // Space type for layout
                            css: 'my_permissions', // CSS class for styling
                            rows: [
                                {
                                    cols: [
                                        {
                                            view: 'combo', // Combo box for filtering permissions
                                            id: 'FilterFather', // Unique ID for the combo
                                            label: _('Buscar Permiso'), // Label for the combo
                                            labelPosition: 'top', // Position of the label
                                            css: 'my_filter', // CSS class for styling
                                            options: [], // Options for the combo
                                            on: {
                                                onChange(newVal) {
                                                    // Event handler for change
                                                    $$('dataview').filter(
                                                        // Filtering dataview based on input
                                                        function (obj) {
                                                            return obj.id.toString().indexOf(newVal) != -1;
                                                        },
                                                    );
                                                },
                                            },
                                        },
                                    ],
                                },
                                {
                                    view: 'grouplist', // Group list for displaying permissions
                                    id: 'dataview', // Unique ID for the dataview
                                    xCount: 1, // Number of columns in the group list
                                    onClick: {
                                        metadata_config_check: function (e, id) {
                                            // Click event handler for items
                                            var item = this.getItem(id); // Get the clicked item
                                            if (item.checkState == 'Blocked') {
                                                // Blocked permissions behave as disabled (not clickable)
                                                return;
                                            }
                                            item.markCheckbox = item.markCheckbox ? 0 : 1; // Toggle checkbox state
                                            this.updateItem(id, item); // Update the item in the list
                                            var vlist = this; // Reference to the grouplist
                                            /**
                                             * Reverts the checkbox to its previous state (used when saving fails).
                                             */
                                            function revertCheckbox() {
                                                item.markCheckbox = item.markCheckbox ? 0 : 1; // Restore previous state
                                                vlist.updateItem(id, item); // Repaint the item
                                            }
                                            var step = $$('ScopeTab').getValue(); // Active step
                                            var mode = $$('PermissionsMode').getValue(); // Current action type (Allow | Deny)
                                            var permAdd = item.markCheckbox == 1 ? item.permId : ''; // Backend permission id to assign
                                            var permDelete = item.markCheckbox == 0 ? item.permId : ''; // Backend permission id to unassign
                                            /**
                                             * Saves a single permission change against the given save resource.
                                             * Reverts the checkbox when the request fails or the backend rejects it.
                                             * @param {string} resource - Save resource name (SavePermissionsUser | SavePermissionsOperation | SavePermissionsGlobally).
                                             * @param {Object} params - Body of the request.
                                             */
                                            function savePermissionChange(resource, params) {
                                                webix
                                                    .ajax() // AJAX request to save the permission change
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'UserManagement/' + resource,
                                                        params,
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                revertCheckbox(); // Restore the checkbox on request failure
                                                                webix.message(_('Error! ')); // Show error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var resp = JSON.parse(text); // Parse response
                                                                if (resp.HasError) {
                                                                    revertCheckbox(); // Restore the checkbox when the backend rejects the change
                                                                    webix.message({
                                                                        type: 'alert-error', // Error message with the backend detail
                                                                        text:
                                                                            resp.AlertMessage != undefined &&
                                                                            resp.AlertMessage != ''
                                                                                ? resp.AlertMessage
                                                                                : _('Error! '),
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                            if (step == 'User') {
                                                var userIdSave = $$('Username').getValue(); // Selected user
                                                if (userIdSave == '' || userIdSave == undefined) {
                                                    revertCheckbox(); // No user selected: nothing to save
                                                    return;
                                                }
                                                savePermissionChange('SavePermissionsUser', {
                                                    userId: userIdSave, // User whose permissions are being edited
                                                    permAdd: permAdd,
                                                    permDelete: permDelete,
                                                    mode: mode, // Current action type (Allow | Deny)
                                                });
                                                return;
                                            }
                                            if (step == 'Operation') {
                                                var roleIdSave = $$('TypeUser').getValue(); // Selected role
                                                if (roleIdSave == '' || roleIdSave == undefined) {
                                                    revertCheckbox(); // No role selected: nothing to save
                                                    return;
                                                }
                                                savePermissionChange('SavePermissionsOperation', {
                                                    roleId: roleIdSave, // Role whose denials are being edited
                                                    permAdd: permAdd,
                                                    permDelete: permDelete,
                                                    mode: mode, // Current action type (Allow | Deny)
                                                });
                                                return;
                                            }
                                            if (step == 'Global') {
                                                var roleIdGlobal = $$('TypeUser').getValue(); // Selected role
                                                if (roleIdGlobal == '' || roleIdGlobal == undefined) {
                                                    revertCheckbox(); // No role selected: nothing to save
                                                    return;
                                                }
                                                savePermissionChange('SavePermissionsGlobally', {
                                                    roleId: roleIdGlobal, // Role whose permissions are being edited
                                                    permAdd: permAdd,
                                                    permDelete: permDelete,
                                                    mode: mode, // Current action type (Allow | Deny)
                                                });
                                            }
                                        },
                                    },
                                    template: function (obj) {
                                        // Template for rendering items
                                        return (
                                            `
                      <span class='metadata_config_check webix_icon wxi-checkbox-` +
                                            (obj.markCheckbox ? 'marked' : 'blank') +
                                            (obj.checkState == 'Blocked' ? ' check-blocked' : '') +
                                            ` +square-o'></span>
                      <div style="width: 100%;height: 100%;">
                        <p class="my-text-list">` +
                                            obj.value +
                                            `</p>
                      </div>
                      `
                                        );
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };
    }
}

// FILE DOCUMENTED
